import { useState } from 'react';

export default function Contact() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('firstName', formData.firstName);
      formBody.append('lastName', formData.lastName);
      formBody.append('email', formData.email);
      formBody.append('phone', formData.phone);
      formBody.append('message', formData.message);

      const response = await fetch('https://readdy.ai/api/form/d5s2nam6ql8jq9ml8mqg', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          message: ''
        });
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section id="contact" className="bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">Get in Touch</h2>
          <p className="text-lg text-gray-400">Questions? We are here to help.</p>
        </div>

        <form id="contact-form" data-readdy-form onSubmit={handleSubmit} className="mb-12">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
            <input
              type="text"
              name="firstName"
              placeholder="First Name"
              value={formData.firstName}
              onChange={(e) => setFormData({...formData, firstName: e.target.value})}
              className="w-full px-6 py-4 bg-white rounded-xl text-gray-900 placeholder-gray-400 outline-none focus:ring-2 focus:ring-[#2563EB]"
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name"
              value={formData.lastName}
              onChange={(e) => setFormData({...formData, lastName: e.target.value})}
              className="w-full px-6 py-4 bg-white rounded-xl text-gray-900 placeholder-gray-400 outline-none focus:ring-2 focus:ring-[#2563EB]"
              required
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-5">
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={(e) => setFormData({...formData, email: e.target.value})}
              className="w-full px-6 py-4 bg-white rounded-xl text-gray-900 placeholder-gray-400 outline-none focus:ring-2 focus:ring-[#2563EB]"
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone"
              value={formData.phone}
              onChange={(e) => setFormData({...formData, phone: e.target.value})}
              className="w-full px-6 py-4 bg-white rounded-xl text-gray-900 placeholder-gray-400 outline-none focus:ring-2 focus:ring-[#2563EB]"
              required
            />
          </div>

          <textarea
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={(e) => setFormData({...formData, message: e.target.value})}
            maxLength={500}
            rows={5}
            className="w-full px-6 py-4 bg-white rounded-xl text-gray-900 placeholder-gray-400 outline-none focus:ring-2 focus:ring-[#2563EB] mb-5 resize-none"
            required
          ></textarea>

          <button
            type="submit"
            disabled={isSubmitting}
            className="w-full py-4 bg-[#2563EB] text-white rounded-xl font-medium hover:bg-[#1d4ed8] transition-colors flex items-center justify-center gap-2 text-lg whitespace-nowrap cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Sending...' : (
              <>
                Send Message
                <i className="ri-send-plane-fill"></i>
              </>
            )}
          </button>

          {submitStatus === 'success' && (
            <div className="mt-4 p-4 bg-green-500/20 border border-green-500 rounded-xl text-green-300 text-center">
              Thank you! Your message has been sent successfully.
            </div>
          )}

          {submitStatus === 'error' && (
            <div className="mt-4 p-4 bg-red-500/20 border border-red-500 rounded-xl text-red-300 text-center">
              Sorry, there was an error sending your message. Please try again.
            </div>
          )}
        </form>

        <div className="flex flex-col md:flex-row items-center justify-center gap-8 text-white">
          <div className="flex items-center gap-3">
            <i className="ri-phone-line text-xl"></i>
            <span className="text-sm">(404) 852-7336</span>
          </div>
          <div className="flex items-center gap-3">
            <i className="ri-map-pin-line text-xl"></i>
            <span className="text-sm">320 W. Lanier Ave. Ste 226, Fayetteville, GA 30214</span>
          </div>
          <div className="flex items-center gap-3">
            <i className="ri-time-line text-xl"></i>
            <span className="text-sm">Mon-Sat 9AM-7PM</span>
          </div>
        </div>
      </div>
    </section>
  );
}
